export const STRINGS = {
  DEHAAT_BUSINESS_APP: 'DeHaat-Business APP',
  DEHAAT_FARMER_APP: 'DeHaat-Farmer APP',
  PAGE_TITLE: 'DeHaat | Agri Finance',
  PAGE_DESCRIPTION:
    'DeHaat connects farmers to suppliers and buyers on a single platform. Online marketplace providing all the agricultural products and services to farmers.',
  PAGE_HEADING: 'Agri Finance',
  SUB_HEADING: 'Credit',
  DESCRIPTION:
    'Right input at right time makes a huge difference in the crop production level - but unfortunately our farmers may not always have the required funds for large purchases at the right time. Our goal is to bring micro-financing for input purchase in partnership with leading agro financing institutions of the country.',
  SECOND_SUBHEADING: 'Insurance',
  INSURANCE_DESCRIPTION:
    'All said and done, nature still has an upper-hand on agricultural outcome - so crop insurance is very vital for financial viability of farming and farmer’s livelihood. We are working closely with leading agro insurance companies in the country to bring right insurance products for benefit of the farmers in our network.',
}

export const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.DEHAAT_FARMER_APP,
    appName: STRINGS.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.DEHAAT_BUSINESS_APP,
    appName: STRINGS.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]
